<template>
  <el-dialog
    ref="addEditDialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="h800_dialog abow_dialog"
    width="1100px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <el-form
      ref="dialogAddEditForm"
      :model="dialogAddEditForm"
      :rules="dialogAddEditFormRules"
      class="add-edit-view-form"
      @submit.native.prevent
    >
      <div class="modal-box">
        <h3 class="modal-title">
          基础信息
        </h3>
        <div class="modal-row-box">
          <el-row
            :gutter="10"
            style="display: flex; align-items: flex-end;"
          >
            <el-col :span="12">
              <el-form-item
                label="问题类型"
                required
              >
                <el-radio-group v-model="dialogAddEditForm.type">
                  <el-radio :label="2">
                    单选题
                  </el-radio>
                  <el-radio :label="3">
                    多选题
                  </el-radio>
                  <el-radio :label="4">
                    问答题
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              v-if="dialogAddEditForm.type === 2 || dialogAddEditForm.type === 3"
              :span="12"
              class="button-col"
            >
              <el-button
                type="primary"
                plain
                round
                size="mini"
                icon="el-icon-plus"
                @click="handleAddOption"
              >
                添加问题选项
              </el-button>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                label="问题内容(题干)"
                prop="question"
              >
                <el-input
                  v-model="dialogAddEditForm.question"
                  type="textarea"
                  :autosize="{minRows: 2}"
                  maxlength="256"
                  class="textarea-item"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <div
            v-for="(answerItem, index) in dialogAddEditForm.answerOptions"
            :key="index"
          >
            <el-divider
              content-position="left"
              class="divider-title"
            >
              <h5>选项{{ index + 1 }}</h5>
            </el-divider>
            <el-row :gutter="10">
              <el-col :span="3">
                <el-form-item
                  label="选项值"
                  :rules="dialogAddEditFormRules.optionValue"
                  :prop="'answerOptions.' + index + '.optionValue'"
                >
                  <el-select
                    v-model="answerItem.optionValue"
                    placeholder="请选择选项的值"
                    clearable
                    filterable
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in optionValueList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="选项内容"
                  :rules="dialogAddEditFormRules.optionText"
                  :prop="'answerOptions.' + index + '.optionText'"
                >
                  <el-input
                    v-model="answerItem.optionText"
                    maxlength="64"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="是否追加录入文本"
                  required
                >
                  <el-radio-group v-model="answerItem.isAddToText">
                    <el-radio :label="1">
                      是
                    </el-radio>
                    <el-radio :label="2">
                      否
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col
                :span="3"
                style="text-align: right;"
              >
                <el-form-item label=" ">
                  <el-button
                    type="danger"
                    plain
                    round
                    size="mini"
                    icon="el-icon-close"
                    @click="handleDeleteOption(answerItem)"
                  >
                    删除问题选项
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item prop="remark">
                <el-input
                  v-model="dialogAddEditForm.remark"
                  type="textarea"
                  placeholder="请输入备注说明"
                  maxlength="128"
                  style="margin-top:10px;"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>

    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        @click="handleSave"
      >
        保存
      </el-button>
      <el-button @click="modalClose">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>
<script>

// dialog拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// API
import { saveQuestionApi, viewQuestionApi } from '@/api/v2/question'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      dialogAddEditForm: {
        answerOptions: []
      },
      dialogAddEditFormRules: {
        question: [
          { required: true, message: '请输入问题题干内容', trigger: 'blur' },
          { max: 256, message: '问题题干内容不能超过 256 字符', trigger: 'blur' }
        ],
        optionValue: [
          { required: true, message: '请选择问题选项值', trigger: 'change' }
        ],
        optionText: [
          { required: true, message: '请输入问题选项内容', trigger: 'blur' },
          { max: 64, message: '问题选项内容不能超过 64 字符', trigger: 'blur' }
        ],
        remark: [
          { max: 128, message: '备注说明不能超过 128 字符', trigger: 'blur' }
        ]
      },
      valueArray: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      optionValueList: []
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this;

        _this.dialogAddEditForm = {
          type: 2,
          question: '',
          remark: '',
          // 问题答案选项明细内容
          answerOptions: [],
          // 答案选项内容JSON字符串
          questionOptionData: ''
        }
        _this.optionValueList = []
        _this.valueArray.forEach(item => {
          _this.optionValueList.push({ label: item, value: item })
        })
        // 获取题库-问题信息
        if (_this.eventType === 'edit') {
          _this.initQuestionData()
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 初始化对象数据
    initQuestionData() {
      let _this = this;
      viewQuestionApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        _this.dialogAddEditForm = {
          id: data.id,
          type: data.type,
          question: data.question,
          remark: data.remark,
          answerOptions: [],
          questionOptionData: ''
        }

        // 设置修改前的选择题答案选项内容
        if (data.type === 2 || data.type === 3) {
          data.questionOptionDtoList.forEach(item => {
            _this.dialogAddEditForm.answerOptions.push({
              optionType: item.optionType,
              optionText: item.optionText,
              optionValue: item.optionValue,
              isAddToText: item.isAddToText
            })
          })
        }

      })
    },
    // 增加选择题答案选项
    handleAddOption() {
      this.dialogAddEditForm.answerOptions.push({ optionType: 1, optionText: '', optionValue: '', isAddToText: 2 })
    },
    // 删除选择题答案选项
    handleDeleteOption(operateItem) {
      let _this = this;
      let index = _this.dialogAddEditForm.answerOptions.findIndex(item => {
        return item === operateItem
      })
      if (index >= 0) {
        _this.dialogAddEditForm.answerOptions.splice(index, 1)
      }
    },
    // 保存
    handleSave() {
      let _this = this;
      _this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          if (_this.dialogAddEditForm.type === 2 || _this.dialogAddEditForm.type === 3) {
            if (_this.dialogAddEditForm.answerOptions.length === 0) {
              _this.$message({ message: '问题选项数据为空', type: 'warning' })
              return false
            }
            let optionValueArray = []
            _this.dialogAddEditForm.answerOptions.forEach(item => {
              optionValueArray.push(item.optionValue)
            })
            // 验证选择题选项值是否存在重复
            if (new Set(optionValueArray).size !== optionValueArray.length) {
              _this.$message({ message: '问题选项值存在重复，不能保存', type: 'warning' })
              return false
            }
          }

          _this.$confirm('确认保存，是否继续？', "系统提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: 'warning', center: true }).then(async () => {
            // 转换选项内容为JSON字符串
            _this.dialogAddEditForm.questionOptionData = _this.dialogAddEditForm.type === 2 || _this.dialogAddEditForm.type === 3 ? JSON.stringify(_this.dialogAddEditForm.answerOptions) : ''

            saveQuestionApi(_this.dialogAddEditForm).then(() => {
              _this.$message({ message: '保存成功', type: 'success' })
              _this.$emit('reloadData')
              _this.modalClose()
            }).catch(() => { })
          }).catch(() => { })
        }
      })
    },
    // 关闭弹框
    modalClose() {
      let _this = this;
      // 直接修改父组件的属性
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogAddEditForm.clearValidate()
    }
  }
}
</script>
<style lang="scss"  scoped>
.textarea-item {
  ::v-deep .el-textarea__inner {
    margin-top: 0px;
  }
}
::v-deep .el-form-item__error {
  left: 10px !important;
}
.tips-col {
  padding: 5px;
  min-height: 20px !important;
}
.button-col {
  text-align: right;
  min-height: 32px;
}
.divider-title {
  h5 {
    color: #409eff;
  }
}
</style>
